import React from 'react';

import KubernetesBlue from '../../images/kubernetes-2.svg';
import Kubernetes from '../../images/kubernetes.svg';

export const KubernetesLogo = () => {
  return <img height="18" src={Kubernetes} alt="Kubernetes logo" />;
};

export const KubernetesBlueLogo = () => {
  return <img height="24" src={KubernetesBlue} alt="Kubernetes logo" />;
};
